import type { BoardTile } from '../../model/board/BoardTypes';

/**
 * Default 12-tile board for the demo: 3 rows of 4 tiles in a snake layout.
 * Mix of cash, clue, location, bonus, and a finish tile that resets the
 * lap. The MMS-shaped variant will swap tile labels + glyphs for crime-
 * scene locations + suspect interrogations.
 */
export const DEFAULT_BOARD_TILES: readonly BoardTile[] = [
  { id: 'start', kind: 'start', label: 'START', reward: 0 },
  { id: 'lib', kind: 'clue', label: 'Library', reward: 25 },
  { id: 'cash-1', kind: 'cash', label: '+50', reward: 50 },
  { id: 'kit', kind: 'location', label: 'Kitchen', reward: 80 },
  { id: 'cash-2', kind: 'cash', label: '+100', reward: 100 },
  { id: 'lounge', kind: 'clue', label: 'Lounge', reward: 25 },
  { id: 'bonus', kind: 'bonus', label: 'Bonus', reward: 150 },
  { id: 'cash-3', kind: 'cash', label: '+50', reward: 50 },
  { id: 'study', kind: 'location', label: 'Study', reward: 80 },
  { id: 'cash-4', kind: 'cash', label: '+100', reward: 100 },
  { id: 'attic', kind: 'clue', label: 'Attic', reward: 25 },
  { id: 'finish', kind: 'finish', label: 'SOLVED!', reward: 500 },
];
